import { toast } from 'sonner';
import { useMutation } from '@apollo/client/react';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { ToggleIntegrationDocument } from 'src/graphql/actions/integration/toggleIntegration.mutation';
import { ClientError, getApiError } from 'src/utils/errors';
import { Button } from '@/components/ui/button';

import { useIntegration } from '../model';
import { refetchIntegrations } from '../api';

const DisconnectDialog = () => {
  const {
    disconnect: { isOpen, integrationId },
    resetIntegration,
  } = useIntegration();
  const [toggleIntegration, { loading }] = useMutation(ToggleIntegrationDocument, {
    onCompleted: refetchIntegrations,
  });

  const onDisconnect = async () => {
    try {
      const { data } = await toggleIntegration({ variables: { integrationId: integrationId! } });
      if (data?.toggleIntegration?.success) {
        toast.success('Integration disconnected');
        resetIntegration();
      } else {
        throw new ClientError(data?.toggleIntegration?.errors?.[0]);
      }
    } catch (error) {
      getApiError(error, toast.error);
    }
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) resetIntegration();
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to disconnect this integration?</AlertDialogTitle>
          <AlertDialogDescription>
            Assets from this integration will show a Disconnected status in your escrows and backups. We won&apos;t be
            able to deposit new versions until you reconnect the integration.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button variant="destructive" onClick={onDisconnect} isLoading={loading}>
            Disconnect anyway
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DisconnectDialog;
